import styled from 'styled-components';

import { PageContentContainer } from '~src/styles/containers.sc';
import { MainContainerAnimation } from '~src/styles/animations';

export const PageContentContainerExt = styled(PageContentContainer)`
  padding-top: 30px;
`;

export const MainContainerAnimationExt = styled(MainContainerAnimation)`
  margin-top: 30px;
`;
